/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ShapeRectHIcon24Regular = forwardRef('ShapeRectHIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.25 8A3.75 3.75 0 0 1 6 4.25h12A3.75 3.75 0 0 1 21.75 8v8A3.75 3.75 0 0 1 18 19.75H6A3.75 3.75 0 0 1 2.25 16V8ZM6 5.75A2.25 2.25 0 0 0 3.75 8v8A2.25 2.25 0 0 0 6 18.25h12A2.25 2.25 0 0 0 20.25 16V8A2.25 2.25 0 0 0 18 5.75H6Z" })));
});
